<template>
  <div>
    <div class="section-header">
      <h1>Progress</h1>
    </div>
    <div class="card-rows">
      <div class="card card--transparent full-width" v-if="User.profile.allow_daily_exercises">
        <h1 style="text-align: center">Percent of Completed Exercises</h1>
        <completed style="height: 30vh; min-height: 200px" :userId="User.id" />
      </div>
      <div v-if="User.profile.allow_self_reflect" class="full-width">
        <kpi :kpi="kpi" v-for="kpi in kpis" :key="kpi.id" />
        <well-being v-for="(values, title) in graphs"
          :title="title"
          :computedData="values.data"
          :color="values.graph_color"
          :key="title"
          />
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/services/api/authUser";
import modal from "@/components/modal";
import kpiChart from "@/components/kpiChart";
import axios from "axios";
import completed from "@/components/charts/completed";
import wellBeing from "@/components/charts/wellBeing";

export default {
  components: {
    kpi: kpiChart,
    wellBeing,
    modal,
    completed,
  },
  data() {
    return {
      loadingWord: true,
      loadingKPIs: true,
      loadingCharts: true,
      User,
      graphs: {},
      kpis: [],
      chartEndPoint: `${process.env.VUE_APP_API_URL}clients/surveys/info/`,
    };
  },
  created() {
    console.log(User)
    axios
      .get(`${process.env.VUE_APP_API_URL}clients/kpis/chart_info/`)
      .then(({ data }) => {
        this.kpis = data;
      });

    axios
      .get(this.chartEndPoint)
      .then(({ data }) => {
        this.graphs = data;
        this.loading = false;
      })
      .finally(() => {
        this.$emit("finished");
      });
  },
  watch: {
    display(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.$eventHub.$emit("tutorial", "progress");
        }, 100);
      }
    }
  }
};
</script>
